<template>
  <div class="controlbox">
    <div class="control-search" style="margin-top: 30px; display: flex; align-items: center; flex-wrap: nowrap;">
      <el-select v-model="channelNo" placeholder="请选择储物柜" clearable style="width: 160px; margin-right: 10px;">
        <el-option
          v-for="item in dict.type.locker_no"
          :key="item.value"
          :label="item.label"
          :value="item.value"
        ></el-option>
      </el-select>
      <el-input
        placeholder="请输入设备名称"
        v-model="deviceName"
        class="input-with-select"
        style="height: 100%; width: 200px; margin-right: 10px;"
      >
      </el-input>
      <el-button icon="el-icon-search" @click="getList"></el-button>
    </div>
    <div class="legend">
      <span class="legend-item"><i class="legend-dot legend-gray"></i>未存放</span>
      <span class="legend-item"><i class="legend-dot legend-green"></i>已存放</span>
      <span class="legend-item"><i class="legend-dot legend-red"></i>已超期</span>
    </div>
    <div class="control-content" style="margin-top: 20px;">
      <div v-for="(group, key) in groupedDevices" :key="key" style="margin-bottom: 16px;">
        <div class="group-title">{{ getChannelLabel(key) }}</div>
        <div class="control-panel_box">
          <div
            class="panel-item"
            v-for="(item, index) in group"
            :key="index"
          >
            <div class="item-box">
              <div
                :class="{
                  'item-img-smartLocker-gray':
                    item.activeStatus === '0' || item.activeStatus === null,
                  'item-img-smartLocker-green': item.activeStatus === '1',
                  'item-img-smartLocker-red': item.activeStatus === '2',
                }"
                :title="getStatusText(item.activeStatus)"
              ></div>
              <div class="item-font">{{ item.equipmentName }}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  listEquipment,
  controlDevice,
} from "@/api/src/equipment";
export default {
  name: "smartLockerPanelView",
  components: {},
  dicts: ["locker_no"],
  props: {
    deviceList: {
      type: Array,
    },
    areaCode: {
      type: String,
    },
  },

  data() {
    return {
      loadingText: "加载中...",
      equipList: this.deviceList,
      waterAllList: [],
      value: true,
      regionCode: this.areaCode,
      code: "cabinet",
      deviceName: null,
      channelNo: null,
      offLine: false,
    };
  },
  computed: {
    groupedDevices() {
      const groups = {};
      this.waterAllList.forEach((item) => {
        const key = item.channelNo || "";
        if (!groups[key]) {
          groups[key] = [];
        }
        groups[key].push(item);
      });
      const sortedKeys = Object.keys(groups).sort((a, b) => {
        if (a === "") return 1;
        if (b === "") return -1;
        return a.localeCompare(b);
      });
      const result = {};
      sortedKeys.forEach((key) => {
        result[key] = groups[key];
      });
      return result;
    },
  },
  watch: {
    deviceList(newVal) {
      this.equipList = newVal;
    },
    areaCode(newVal) {
      this.regionCode = newVal;
      this.getList();
    },
    channelNo() {
      this.getList();
    },
  },
  created() {
    this.init();
  },
  mounted() {},
  methods: {
    getStatusText(activeStatus) {
      if (activeStatus === '1') return '已存放';
      if (activeStatus === '2') return '已超期';
      return '未存放';
    },
    getChannelLabel(key) {
      if (!key) return "未分组";
      const dictItem = (this.dict.type.locker_no || []).find(
        (d) => d.value === key
      );
      return dictItem ? dictItem.label : key;
    },
    init() {
      this.getList();
    },
    getList() {
      this.loading = true;
      listEquipment({
        categoryCode: this.code,
        equipmentName: this.deviceName,
        channelNo: this.channelNo,
        pageSize: 10000,
      }).then((response) => {
        this.waterAllList = response.rows;
        const result = this.waterAllList.find((item) => {
          return item.onlineStatus === "1";
        });
        if (result) {
          this.offLine = false;
        } else {
          this.offLine = true;
        }
        this.$emit("offLine", this.offLine);
        this.loading = false;
      });
    },
    controlChange(val, equipmentCode) {
      if (val === "1") {
        this.open(equipmentCode);
      } else {
        this.close(equipmentCode);
      }
    },
    open(equipmentCode) {
      this.$confirm("确定要打开吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.$prompt("请设置灌溉时长（分钟）", "提示", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            inputType: "number",
            inputPattern: /^[1-9]\d*$/,
            inputErrorMessage: "请输入正整数",
            closeOnClickModal: false,
          })
            .then(({ value }) => {
              this.controlDevice(value, "2", equipmentCode);

              this.loading = true;
              this.loadingText = "打开中...";
            })
            .catch(() => {
              this.$message({
                type: "info",
                message: "取消输入",
              });
              this.getList();
            });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消打开",
          });
          this.getList();
        });
    },
    close(equipmentCode) {
      this.$confirm("确定要关闭吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.loading = true;
          this.loadingText = "关闭中...";
          this.controlDevice(null, "1", equipmentCode);
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消关闭",
          });
          this.getList();
        });
    },
    controlDevice(value, instructions, equipmentCode) {
      let paramData = {
        instructions: instructions,
        equipmentCode: equipmentCode,
        minute: value,
      };
      controlDevice(paramData)
        .then((response) => {
          this.$message({
            type: "success",
            message: instructions === "2" ? "打开成功" : "关闭成功",
          });
          this.getList();
        })
        .catch((err) => {
          console.log(err);
          this.getList();
        });
    },
  },
};
</script>

<style scoped>
.group-title {
  font-size: 14px;
  font-weight: bold;
  color: #298beb;
  padding: 8px 12px;
  border-left: 3px solid #298beb;
  margin-bottom: 8px;
  background: rgba(41, 139, 235, 0.06);
}
.legend {
  display: flex;
  gap: 18px;
  margin: 10px 4px;
}
.legend-item {
  display: flex;
  align-items: center;
  font-size: 13px;
  color: #c0d4ed;
}
.legend-dot {
  display: inline-block;
  width: 12px;
  height: 12px;
  border-radius: 50%;
  margin-right: 5px;
}
.legend-dot.legend-gray {
  background: #a0a8b5;
}
.legend-dot.legend-green {
  background: #67c23a;
}
.legend-dot.legend-red {
  background: #f56c6c;
}
</style>
